<template>
    <!-- Generato da claude — Deskalo 2: split-panel login (navy sinistra, form destra) -->
    <div class="dk-login-wrap">

        <!-- Pannello sinistro: brand navy -->
        <div class="dk-login-left">
            <div class="dk-login-tagline">
                <strong>Il tuo desk, ovunque</strong>
                Gestisci prenotazioni, pagamenti<br>e abbonamenti direttamente<br>dal tuo telefono
            </div>
        </div>

        <!-- Pannello destro: form -->
        <div class="dk-login-right">
            <div class="dk-login-box">
                <div class="dk-login-logo-wrap">
                    <img src="@/assets/img/deskalo_logo_definitivo_trasparente.png" alt="Deskalo" class="dk-login-logo-img">
                </div>
                <div class="dk-login-subtitle">Accedi con email e PIN</div>

                <div class="mb-3">
                    <label class="form-label fw-bold">Email</label>
                    <input
                        type="email"
                        class="form-control form-control-lg"
                        placeholder="mario.rossi@email.it"
                        v-model="credenziali.EMAIL"
                        @keyup.enter="login()"
                        autocomplete="email"
                    >
                </div>

                <div class="mb-4">
                    <label class="form-label fw-bold">PIN</label>
                    <input
                        type="password"
                        class="form-control form-control-lg"
                        placeholder="PIN a 5 cifre"
                        maxlength="5"
                        v-model="credenziali.PIN"
                        @keyup.enter="login()"
                        autocomplete="current-password"
                        inputmode="numeric"
                    >
                </div>

                <div class="d-grid">
                    <button class="btn btn-dk-orange btn-lg" @click="login()">
                        <i class="fal fa-sign-in-alt fa-fw me-1"></i> Accedi
                    </button>
                </div>

                <div class="mt-4 text-center">
                    <small class="text-muted">
                        Per ricevere il PIN contatta la segreteria<br>
                        <a href="mailto:info@isprint.it" class="text-muted">info@isprint.it</a>
                    </small>
                    <div class="mt-2">
                        <small class="text-muted" style="font-size:.7rem">v{{$root.VERSIONE}}</small>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// Generato da claude — Deskalo 2: login email+PIN su G_T_SOCI
export default {
    name: 'Login',
    data: function() {
        return {
            credenziali: {
                EMAIL: '',
                PIN: ''
            }
        }
    },
    methods: {
        login() {
            if (!this.credenziali.EMAIL || !this.credenziali.PIN) {
                global.utils.alert.warning('Inserisci email e PIN');
                return;
            }
            global.utils.ajax('deskalo/login', { EMAIL: this.credenziali.EMAIL, PIN: this.credenziali.PIN }, (response) => {
                if (response.esito == 0) {
                    global.utils.setCookie('session_token', response.data.SESSION_TOKEN);
                    this.$root.startHandler();
                } else {
                    global.utils.alert.warning(response.messaggio || 'Credenziali non valide');
                }
            });
        }
    },
    created: function() {
        // nessuna navbar su login — assicura che il body non abbia padding-top residuo
    }
}
</script>
